import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Urgency {
  id: string
  name: string
}

export interface UseUrgenciesResult {
  urgencies: Urgency[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useUrgencies(fetchOnMount = false): UseUrgenciesResult {
  const [urgencies, setUrgencies] = useState<Urgency[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ urgencies: Urgency[] }>('/admin/conversation-management/urgencies/dropdown')
      console.log('Urgencies response:', res)
      setUrgencies(res.urgencies || [])
    } catch (e) {
      console.error('Failed to fetch urgencies:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch urgencies')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { urgencies, loading, error, refetch }
}
